import { gql } from '@apollo/client';

export const CREATE_NE_AGS = gql`
  mutation createNeAGS($nutritionalEvaluationAgs: NeAgsInput!) {
    createNeAgs(nutritionalEvaluationAgs: $nutritionalEvaluationAgs) {
      id
    }
  }
`;
